require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./projecten-visie-vesting-den-bosch.json") })
        }
      }, "path---projecten-visie-vesting-den-bosch");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---projecten-visie-vesting-den-bosch!./.cache/json/projecten-visie-vesting-den-bosch.json
// module id = 454
// module chunks = 231608221292675